import { createSlice } from "@reduxjs/toolkit";
import { DefaultPaginable } from "const";
import { handleErrorStopLoading } from "redux/redux-util";

const initCondition = {
  fundName: null,
  fundSubTypeList: [],
  fundIssuerList: [],
  fundDividend: [],
  recommend: true,
  allFundSubType: false,
  allIssuer: false,
};

const initialState = {
  loading: false,
  fundList: [],
  paginable: {
    ...DefaultPaginable,
  },
  endPaging: false,
  total: 0,

  fetchingFundDetail: false,
  fetchingNavDetailList: false,
  fundDetail: {},
  navDetailList: [],
  condition: { ...initCondition },
  factSheetFile: null,
  urlFactsheet: null,
};

const initialData = {
  loading: false,
  fundList: [],
  paginable: {
    ...DefaultPaginable,
  },
  endPaging: false,
  total: 0,
  condition: { ...initCondition },
};

const slice = createSlice({
  initialState,
  name: "fund",
  reducers: {
    reset: (state, action) => {
      return action.payload.hard
        ? initialData
        : {
            ...initialData,
            condition: state.condition,
          };
    },

    searchFund: (state) => {
      state.loading = true;
    },
    searchFundSuccess: (state, action) => {
      state.loading = false;
      state.fundList = [...state.fundList, ...action.payload.fundList];
      state.total = action.payload.total;
      state.paginable = action.payload.paginable;
      if (state.fundList.length >= action.payload.total) {
        state.endPaging = true;
      }
    },
    searchFundFailure: handleErrorStopLoading,

    getFundDetail: (state) => {
      state.fetchingFundDetail = true;
    },
    getFundDetailSuccess: (state, action) => {
      state.fetchingFundDetail = false;
      state.fundDetail = action.payload.fundDetail;
    },
    getFundDetailFailure: (state) => {
      state.fetchingFundDetail = false;
      state.fundDetail = {};
    },

    getNavDetailList: (state) => {
      state.fetchingNavDetailList = true;
    },
    getNavDetailListSuccess: (state, action) => {
      state.fetchingNavDetailList = false;
      state.navDetailList = action.payload.navDetailList;
    },
    getNavDetailListFailure: (state) => {
      state.fetchingNavDetailList = false;
      state.navDetailList = [];
    },
    setFactSheetFile: (state, action) => {
      state.factSheetFile = action.payload.factSheetFile;
    },
    setUrlFactsheet: (state, action) => {
      state.urlFactsheet = action.payload.urlFactsheet;
    },
    filterConditionChange: (state, action) => {
      state.condition = action.payload;
      state.fundList = [];
      state.paginable = { ...DefaultPaginable };
      state.endPaging = false;
      state.total = 0;
    },
    resetCond: (state, action) => {
      state.condition = { ...initCondition, recommend: false };
      state.fundList = [];
      state.paginable = { ...DefaultPaginable };
      state.endPaging = false;
      state.total = 0;
    },
  },
});

export const {
  reset,
  resetCond,
  filterConditionChange,

  searchFund,
  searchFundSuccess,
  searchFundFailure,

  getFundDetail,
  getFundDetailSuccess,
  getFundDetailFailure,

  getNavDetailList,
  getNavDetailListSuccess,
  getNavDetailListFailure,

  setFactSheetFile,
  setUrlFactsheet,
} = slice.actions;

export default slice;
